import { Box, BoxProps, Icon } from '@chakra-ui/react';
import { ReactElement } from 'react';

interface IconTileProps extends BoxProps {
  children: ReactElement;
}

export function IconTile({ children, boxSize = '9', ...props }: IconTileProps) {
  return (
    <Box
      layerStyle="iconTile"
      boxSize={boxSize}
      flexShrink={0}
      css={{
        '& svg': {
          strokeWidth: 1.85,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          vectorEffect: 'non-scaling-stroke',
        },
      }}
      {...props}
    >
      <Icon boxSize="4.5">{children}</Icon>
    </Box>
  );
}
